import { User, UserRoles } from '@/store/auth';
import { LicenseTypeView } from '@/features/regulations/model';

export function hasUserSrViewRights(licenseTypeView: LicenseTypeView, user: User) {
    if (licenseTypeView === 'VIEW_OPEN') {
        return true;
    }
    return licenseTypeView === 'VIEW_LICENSED' && user.roles.includes(UserRoles.SR_LICENSED);
}